module.exports = "https://cdn01.riselinkedu.com/assets/images/bubble.48d17de.png";